exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!bootstrap/dist/css/bootstrap.css"), "");

// module
exports.push([module.id, "[data-v-b98b8592]::-webkit-scrollbar{width:0;height:0;background:transparent}[data-v-b98b8592]::-webkit-scrollbar-thumb{background:rgba(0,0,0,.5)}", ""]);

// exports
